var _g, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRubyTier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "avatars"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_36782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_107_36782",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_107_36782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#FEEBEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    d: "M12 21.333C15.6819 21.333 18.6667 20.4376 18.6667 19.333C18.6667 18.2284 15.6819 17.333 12 17.333C8.31814 17.333 5.33337 18.2284 5.33337 19.333C5.33337 20.4376 8.31814 21.333 12 21.333Z",
    fill: "#F2AEB8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xEF\x8E\xA5",
    d: "M12.6463 17.9463L7.33313 12.1338H17.9334L12.6463 17.9463Z",
    fill: "url(#paint0_radial_107_36782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xEF\x8E\xA5_2",
    d: "M18.6024 11.1402L15.6854 6.85449C15.6073 6.74735 15.477 6.66699 15.3468 6.66699H8.65327C8.52305 6.66699 8.39282 6.74735 8.31469 6.85449L5.39766 11.1402C5.29348 11.3277 5.31952 11.542 5.44975 11.6759L11.7005 18.5331C11.7787 18.6402 11.8828 18.667 12.0131 18.667C12.1172 18.667 12.2214 18.6402 12.2996 18.5331L18.5503 11.6759C18.6806 11.542 18.7066 11.3009 18.6024 11.1402ZM15.3208 7.84556L17.4564 10.9527H13.0028L15.3208 7.84556ZM12.0131 10.8991L9.51275 7.52414H14.4873L12.0131 10.8991ZM8.67932 7.84556L10.9973 10.9527H6.54363L8.67932 7.84556ZM12.0131 17.6224L6.6999 11.8098H17.3002L12.0131 17.6224Z",
    fill: "#EE5056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xEF\x8E\xA5_3",
    d: "M15.4439 8.32143L17.5796 11.4286H13.1259L15.4439 8.32143ZM12.1362 11.375L9.63587 8H14.6104L12.1362 11.375ZM8.80243 8.32143L11.1204 11.4286H6.66675L8.80243 8.32143Z",
    fill: "url(#paint1_diamond_107_36782)"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_107_36782",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.3364 12.4173) rotate(90) scale(5.04911 5.45641)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F74760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5367",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_diamond_107_36782",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8263 13.9026) rotate(90) scale(5.04911 5.45641)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F74760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5367",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_36782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubyTier);
export default __webpack_public_path__ + "static/media/ruby_tier.4b31eb65.svg";
export { ForwardRef as ReactComponent };